import { RemoteLoadUserLocationList } from '@/javascript/data/usecases/maps/remote-load-user-location-list'
import { LoadUserLocationList } from '@/javascript/domain/usecases/maps/load-user-location-list'
import { makeCurrentAccountHttpClientDecorator } from '@/javascript/main/factories/decorators'
import { makeApiUrl } from '@/javascript/main/factories/http'
import { makeUserLocationMapper } from '@/javascript/main/factories/mappers'

export const makeRemoteLoadUserLocationList = (): LoadUserLocationList =>
  new RemoteLoadUserLocationList(
    makeApiUrl('/maps/user_locations'),
    makeCurrentAccountHttpClientDecorator(),
    makeUserLocationMapper()
  )
